import { Skeleton, Stack, Typography } from '@mui/material';
import type { Snapshot, SnapshotReference } from '@repo/api-gw-sdk';

import { SnapshotIndicator } from '@/components/snapshots/SnapshotIndicator';
import { useBackupVaults } from '@/data/vaults/useBackupVaults';
import { isDateValid } from '@/utils/dateTime';
import { DATE_TIME_FORMAT, dayjs } from '@/utils/dayjs';

export const LatestSnapshotIndicator = ({
  latestSnapshot,
  isLoading,
}: {
  latestSnapshot?: Snapshot | SnapshotReference;
  isLoading: boolean;
}) => {
  const { vaults, isLoading: isLoadingVaults } = useBackupVaults();
  const vault =
    latestSnapshot && vaults.find((v) => v.id === latestSnapshot.vaultId);

  if (isLoading || isLoadingVaults) {
    return <Skeleton variant='text' width='250px' height='24px' />;
  }

  return (
    <Stack direction={'row'} alignItems={'center'} gap='12px'>
      {vault?.backgroundColor && (
        <SnapshotIndicator backgroundColor={vault.backgroundColor} />
      )}
      <Typography variant='subtitle1'>
        {isDateValid(latestSnapshot?.pointInTime)
          ? `Last backed up on ${dayjs.utc(latestSnapshot?.pointInTime).format(DATE_TIME_FORMAT)} UTC`
          : 'The last backup date is unknown'}
      </Typography>
    </Stack>
  );
};
